import { Image, Svg, Text, View } from '@react-pdf/renderer';
import * as React from 'react';
import { PdfCrossCheck, styles } from '../PDFStyle';
import check from '../../../images/check.svg';
import cross from '../../../images/X.svg';
import PDFSmallLetter from '../PDFSmallLetter/PDFSmallLetter';
import SVGCheck from '../PDFLayout/SVGCheck';
import SVGX from '../PDFLayout/SVGX';
interface IPDFTableHeaderProps {
    columns: string[];
    viewStyle?: any;
    style?: any;
}

const PDFTableHeader = (props: IPDFTableHeaderProps) => {
    const { columns, style, viewStyle } = props;

    return (
        <>
            {columns.map((col, index) => {
                if (col.startsWith('@') && col.includes('(')) {
                    let symbolToSplit = col.split('@');
                    let arrSymbol = symbolToSplit[1].split('(');
                    return (
                        <View style={{ width: `${100 / columns.length}%` }}>
                            <PDFSmallLetter normal={arrSymbol[0]} small={arrSymbol[1].replace(')', '')} />
                        </View>
                    );
                }
                let textAlign = index === 0 ? 'start' : 'center';
                if (index === 1 && col.includes('ᵀᴹ')) col = col.replace('ᵀᴹ', '\u2122');
                return col === PdfCrossCheck.check || col === PdfCrossCheck.cross ? (
                    <View style={[{ width: `${100 / columns.length}%` }, styles.imgCenter]} key={col}>
                        {col === PdfCrossCheck.check ? <SVGCheck /> : <SVGX />}
                    </View>
                ) : (
                    <Text style={{ width: `${100 / columns.length}%`, textAlign: textAlign, ...style }} key={col}>
                        {col}
                    </Text>
                );
            })}
        </>
    );
};

export default PDFTableHeader;
